import { twMerge } from "tailwind-merge";

export type Theme = typeof dayTheme;

export const dayTheme = {
  loadingWrapper: {
    tailwind: {
      overlayBg: "bg-white",
    },
  },

  sideBarComponent: {
    background: {
      default: "#FFFFFF",
      tooltip: "#4A5655",
      activeLink: "var(--Primary-20, #D4EBE7)",
    },
    iconAndText: {
      active: "#1F8475",
      inactive: "#899996",
      tooltipText: "#FFFFFF",
    },
    border: {
      sidebar: "var(--Greyscale-20, #E5E7EB)",
    },
    tailWind: {
      white: "bg-white",
      greyscale20: "border-greyscale-20",
    },
  },

  headerComponent: {
    inline: {
      dotActive: "#1f8475",
      dotInactive: "#dd3b3b",
      tooltipBackground: "#4A5655",
      tooltipText: "#fff",
      generalText: "text-[#4a5655]",
    },
    tailwind: {
      buttonBorder: "border-green",
      buttonText: "text-green",
      buttonHoverBg: "hover:bg-green",
      buttonHoverText: "hover:text-white",
      buttonFocusRing: "focus:ring-green-200",
      statusText: "text-lightGrey",
      vesselTitleText: "text-custom-color",
      loadingSpinner: "text-green",
      backButtonBg: "bg-greyscale-10",
      leftArrow: "group-hover:text-white",
    },
    notifications: {
      iconBackground: "bg-[#D4EBE7]",
      iconShape: "text-[#899996]",
      drawerBackground: "bg-white",
      header: "bg-white",
      headerText: "text-gray-900",
      headerIcon: "#292F2D",
      headerBorder: "border-b-[#DFE4E2]",
      border: "border-[#DFE4E2]",
      isReadBackground: "bg-[#F3F4F4]",
      itemBackground: "bg-[#E9F4F3]",
      notificationText: "text-[#4A4E56]",
      readDotBorder: "border-white",
    },
    themeSwitch: {
      switchBorder: "border-gray-400",
      switchDot: "bg-gray-400",
    },
    logInCircle: {
      text: "text-green",
    },
    profileMenu: {
      background: "bg-white",
      text: "#899996",
    },
  },

  home: {
    tailwind: {
      textDefault: "text-gray-900",
      pageBackground: "bg-greyscale-10",
      panelBackground: "bg-white",
      panelShadow: "shadow-md",
      spinner: "text-green",
      backgound: "bg-gray-100",
      greenBg: "bg-green",
    },
  },

  myVesselsTable: {
    searchIcon: {
      iconColor: "#1F8475",
      outerFill: "#E9F4F3",
      innerFill: "#D4EBE7",
      glyphFill: "#1F8475",
    },
    tailwind: {
      tableBorder: "border-greyscale-20",
      textDefault: "text-gray-800",
      emptyStateIconBg: "bg-primary-20",
      emptyStateText: "text-green",
      linkText: "text-green",
      headBorderY: "after:border-gray-300",
    },
  },

  myVesselsTableRow: {
    status: {
      delivered: { border: "border-[#658D1B]", text: "text-[#658D1B]" },
      redelivered: { border: "border-[#B2AD18]", text: "text-[#B2AD18]" },
      canceled: { border: "border-[#BF0002]", text: "text-[#BF0002]" },
      closed: { border: "border-[#007681]", text: "text-[#007681]" },
      fixed: { border: "border-[#292F2D]", text: "text-[#292F2D]" },
      default: { border: "border-lime-600", text: "text-lime-600" },
    },
    dot: {
      active: "#1F8475",
      inactive: "#DD3B3B",
    },
    row: {
      primary: "bg-primary-10",
      primaryDarker: "bg-primary-10",
      primaryMedium: "bg-primary-10",
      hover: "hover:bg-primary-10",
      hoverTwenty: "hover:bg-primary-20",
      text: "text-green",
    },
    tooltip: {
      background: "#307075",
      text: "#FFFFFF",
    },
    tableText: {
      primary: "text-neutral-700",
      secondary: "text-neutral-600",
    },
    rating: {
      A: { textColor: "#FFFFFF", bgColor: "#034938" },
      B: { textColor: "#FFFFFF", bgColor: "#AED36B" },
      C: { textColor: "#FFFFFF", bgColor: "#FFDD15" },
      D: { textColor: "#FFFFFF", bgColor: "#FFAA1C" },
      E: { textColor: "#FFFFFF", bgColor: "#D71920" },
    },
    divider: {
      color: "bg-[#DFE4E2]",
    },
  },
  uwhcAssistant: {
    buttonCenterIcon: "#FFFFFF",
    background: "bg-white",
    border: "border-gray-200",
    text: "text-gray-600",
    textOutput: "text-gray-900",
    chatBorder: "border-blue-100",
    chatBg: "bg-blue-50",
    aiReplyBg: "bg-white",
    aiReplyBorder: "border-gray-200",
    scrolThumb: "[&::-webkit-scrollbar-thumb]:bg-slate-200",
    scrolHover: "hover:[&::-webkit-scrollbar-thumb]:bg-slate-300",
    sendBg: "bg-green",
    sendText: "text-white",
    sendBorder: "border-green",
    inputBg: "bg-white",
    inputText: "text-gray-800",
    inputBorder: "border-gray-300",
    theadBg: "bg-gray-50",
    theadText: "text-gray-600",
    tableBg: "bg-gray-100",
    tableBgOther: "bg-slate-200",
    tableText: "text-gray-800",
    tableInputBg: "bg-white",
    tableInputText: "text-gray-800",
    tableBorder: "border-gray-300",
    buttonBorder: "border-gray-600",
    tableRowEven: "bg-white",
    tableRowOdd: "bg-gray-50",
    tableScroll: "[&::-webkit-scrollbar-thumb]:bg-gray-200",
    details: "text-blue-500",
    boolBadge: {
      yesBg: "bg-emerald-100",
      yesText: "text-emerald-900",
      noBg: "bg-red-100",
      noText: "text-red-700",
      unknownBg: "bg-gray-100",
      unknownText: "text-gray-600",
    },
    blueLine: "bg-blueLine",
    chatUi: {
      overlayBackdrop: "bg-black/50",
      launcherButton:
        "bg-[#1F8475] text-white hover:bg-[#0F7465] focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600",
      panelBg: "bg-white",
      panelBorder: "border-[#CFE0DB]",
      headerBg: "bg-[#DFF2F0]",
      headerBorder: "border-[#DCE7E3]",
      brandIconBg: "bg-[#2F84A5]",
      brandIconShadow: "shadow-[0_10px_24px_rgba(31,132,117,0.24)]",
      brandTag: "bg-[#E8F4F1] text-[#1F8475]",
      titleText: "text-slate-900",
      subtitleText: "text-slate-500",
      connectionConnected: "bg-[#E5F7EF] text-[#197A55]",
      connectionConnecting: "bg-[#FFF2DD] text-[#9A6700]",
      responseBusy: "border-[#C9DBFA] bg-[#EAF2FF] text-[#2358C5]",
      responseIdle: "border-[#DCE7E3] bg-white text-slate-600",
      closeButton: "border-[#DCE7E3] bg-white text-slate-500",
      closeButtonHover: "hover:border-[#B8CAC5] hover:text-slate-800",
      sectionBorder: "border-[#E7EEEB]",
      conversationTitle: "text-slate-900",
      conversationSubtitle: "text-slate-500",
      countBadge: "bg-[#EEF5F3] text-slate-600",
      mainBg: "bg-[#FBFCFC]",
      mainScrollbar: "[&::-webkit-scrollbar-thumb]:bg-[#B7C9C4]",
      mainScrollbarTrack: "[&::-webkit-scrollbar-track]:bg-gray-100",
      assistantAvatarBg: "bg-[#2F84A5]",
      assistantAvatarColor: "#FFFFFF",
      systemAvatarBg: "bg-slate-200",
      systemAvatarColor: "#475569",
      assistantMeta: "text-slate-600",
      userBubble: "border-[#16695D] bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(31,132,117,0.22)]",
      userEyebrow: "text-white/70",
      assistantBubble: "border-[#CBDDD7] bg-[#DFF2F0] text-slate-800",
      systemBubble: "border-slate-200 bg-slate-100 text-slate-700",
      markdownUser: "[&_p]:text-white",
      markdownAssistant: "[&_p]:text-slate-700",
      tableWrap: "border-[#DCE7E3] bg-[#FBFCFC]",
      feedbackButtonActive: "border-[#1F8475] bg-[#1F8475] text-white",
      feedbackButtonIdle: "border-slate-200 bg-white text-slate-500",
      feedbackButtonHover: "hover:bg-slate-100",
      timestamp: "text-slate-400",
      typingBubble: "border-[#CBDDD7] bg-[#F1F7F4] text-slate-800",
      typingDot: "bg-slate-400",
      suggestedBg: "bg-[#F1F7F4]",
      suggestedBorder: "border-[#E9EFED]",
      suggestedChip: "border-[#D7E2DE] bg-white text-slate-600",
      suggestedChipHover: "hover:border-[#9CC9C2] hover:bg-[#F4FBF8]",
      footerBg: "bg-white",
      errorBox: "border-[#F3C9C9] bg-[#FFF5F5] text-[#B42318]",
      input: "border-[#D7E2DE] bg-[#FBFCFC] text-slate-800 placeholder:text-slate-400",
      inputFocus: "focus:border-[#9CC9C2] focus:bg-white",
      sendButton: "bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(31,132,117,0.26)]",
      sendButtonHover: "hover:bg-[#176A5E]",
      sendButtonDisabled: "disabled:bg-[#9DBAB5] disabled:shadow-none",
      helperText: "text-slate-500",
      feedbackModalBackdrop: "bg-slate-950/45",
      feedbackModalPanel: "border-[#D7E2DE] bg-[linear-gradient(180deg,#FFFFFF_0%,#F7FBFA_100%)]",
      feedbackTagText: "text-[#1F8475]",
      feedbackTitle: "text-slate-900",
      feedbackBody: "text-slate-600",
      feedbackClose: "border-[#D7E2DE] bg-white text-slate-500",
      feedbackCloseHover: "hover:text-slate-800",
      feedbackReasonSelected: "border-[#1F8475] bg-[#1F8475] text-white shadow-[0_10px_22px_rgba(31,132,117,0.22)]",
      feedbackReasonIdle: "border-[#D7E2DE] bg-white text-slate-700",
      feedbackReasonHover: "hover:border-[#9CC9C2] hover:bg-[#F4FBF8]",
      feedbackTextarea: "border-[#D7E2DE] bg-white text-slate-700 placeholder:text-slate-400",
      feedbackTextareaFocus: "focus:border-[#9CC9C2]",
      feedbackSubmit: "bg-[#1F8475] text-white shadow-[0_12px_24px_rgba(31,132,117,0.22)]",
      feedbackSubmitHover: "hover:bg-[#176A5E]",
      feedbackSubmitDisabled: "bg-[#B9CCC7]",
    },
  },
  opsKnowledgeAssistant: {
    text: "text-gray-600",
    chatUi: {
      overlayBackdrop: "bg-black/50",
      launcherButton:
        "bg-[#1F8475] text-white hover:bg-[#0F7465] focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600",
      panelBg: "bg-white",
      panelBorder: "border-[#CFE0DB]",
      headerBg: "bg-[#F1F7F4]",
      headerBorder: "border-[#DCE7E3]",
      brandIconBg: "bg-[#1F8475]",
      brandIconShadow: "shadow-[0_10px_24px_rgba(31,132,117,0.24)]",
      brandTag: "bg-[#E8F4F1] text-[#1F8475]",
      titleText: "text-slate-900",
      subtitleText: "text-slate-500",
      connectionConnected: "bg-[#E5F7EF] text-[#197A55]",
      connectionConnecting: "bg-[#FFF2DD] text-[#9A6700]",
      responseBusy: "border-[#C9DBFA] bg-[#EAF2FF] text-[#2358C5]",
      responseIdle: "border-[#DCE7E3] bg-white text-slate-600",
      closeButton: "border-[#DCE7E3] bg-white text-slate-500",
      closeButtonHover: "hover:border-[#B8CAC5] hover:text-slate-800",
      sectionBorder: "border-[#E7EEEB]",
      conversationTitle: "text-slate-900",
      conversationSubtitle: "text-slate-500",
      countBadge: "bg-[#EEF5F3] text-slate-600",
      mainBg: "bg-[#FBFCFC]",
      mainScrollbar: "[&::-webkit-scrollbar-thumb]:bg-[#B7C9C4]",
      mainScrollbarTrack: "[&::-webkit-scrollbar-track]:bg-gray-100",
      assistantAvatarBg: "bg-[#1F8475]",
      assistantAvatarColor: "#FFFFFF",
      systemAvatarBg: "bg-slate-200",
      systemAvatarColor: "#475569",
      assistantMeta: "text-slate-600",
      userBubble: "border-[#16695D] bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(31,132,117,0.22)]",
      userEyebrow: "text-white/70",
      assistantBubble: "border-[#CBDDD7] bg-[#F1F7F4] text-slate-800",
      systemBubble: "border-slate-200 bg-slate-100 text-slate-700",
      markdownUser: "[&_p]:text-white",
      markdownAssistant: "[&_p]:text-slate-700",
      tableWrap: "border-emerald-100 bg-white",
      feedbackButtonActive: "border-[#1F8475] bg-[#1F8475] text-white",
      feedbackButtonIdle: "border-slate-200 bg-white text-slate-500",
      feedbackButtonHover: "hover:bg-slate-100",
      timestamp: "text-gray-400",
      typingBubble: "border-[#CBDDD7] bg-[#F1F7F4] text-slate-800",
      typingDot: "bg-slate-400",
      suggestedBg: "bg-[#F1F7F4]",
      suggestedBorder: "border-[#E9EFED]",
      suggestedChip: "border-[#D7E2DE] bg-white text-slate-600",
      suggestedChipHover: "hover:border-[#9CC9C2] hover:bg-[#F4FBF8]",
      footerBg: "bg-white",
      errorBox: "border-rose-200 bg-rose-50 text-rose-700",
      input: "border-[#D7E2DE] bg-[#FBFCFC] text-slate-800 placeholder:text-slate-400",
      inputFocus: "focus:border-[#9CC9C2] focus:bg-white",
      sendButton: "bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(31,132,117,0.26)]",
      sendButtonHover: "hover:bg-[#176A5E]",
      sendButtonDisabled: "disabled:bg-[#9DBAB5] disabled:shadow-none",
      helperText: "text-gray-500",
      feedbackModalBackdrop: "bg-slate-950/45",
      feedbackModalPanel: "border-[#D7E2DE] bg-[linear-gradient(180deg,#FFFFFF_0%,#F7FBFA_100%)]",
      feedbackTagText: "text-[#1F8475]",
      feedbackTitle: "text-slate-900",
      feedbackBody: "text-slate-600",
      feedbackClose: "border-[#D7E2DE] bg-white text-slate-500",
      feedbackCloseHover: "hover:text-slate-800",
      feedbackReasonSelected: "border-[#1F8475] bg-[#1F8475] text-white shadow-[0_10px_22px_rgba(31,132,117,0.22)]",
      feedbackReasonIdle: "border-[#D7E2DE] bg-white text-slate-700",
      feedbackReasonHover: "hover:border-[#9CC9C2] hover:bg-[#F4FBF8]",
      feedbackTextarea: "border-[#D7E2DE] bg-white text-slate-700 placeholder:text-slate-400",
      feedbackTextareaFocus: "focus:border-[#9CC9C2]",
      feedbackSubmit: "bg-[#1F8475] text-white shadow-[0_12px_24px_rgba(31,132,117,0.22)]",
      feedbackSubmitHover: "hover:bg-[#176A5E]",
      feedbackSubmitDisabled: "bg-[#B9CCC7]",
    },
  },
  circleText: {
    background: "bg-secondary-20",
    text: "text-emerald-800",
  },
  crtDropdown: {
    open: "#1F8475",
    openBg: "bg-[#1F8475]",
    error: "#BF0002",
    closed: "#899996",
    errorText: "text-[#BF0002]",
    hoverGreen: "hover:bg-[#116958]",
  },
  crtDropInput: {
    green: "#05978b",
    placeholderTextGreen: "placeholder:text-[#05978b]",
    greenHover: "hover:border-[#05978b]",
    hoverText: "hover:text-green",
    hoverPlaceholder: "hover:placeholder:text-green",
    focusBorder: "focus:border-[#05978b]",
    focusVisibleBorder: "focus-visible:border-[#05978b]",
    error: "#BF0002",
    borderError: "border-[#BF0002]",
    textError: "text-[#BF0002]",
    placeholderTextError: "placeholder:text-[#BF0002]",
    textDefault: "#d1d5db",
    textGreen: "text-green",
    borderGreen: "border-green",
    dashedBorder: "border-[#3ca394]",
    dashedBg: "bg-[#3ca394]",
  },
  certVesselSelect: {
    tableBorder: "border-gray-200",
    tableBg: "bg-white",
    hoverSelect: "hover:bg-[#F3F4F4]",
    tableText: "text-gray-800",
    tabsBg: "#DFE4E2",
  },
  certDocumentIcon: {
    circle: "#CCE4E6",
    primary: "#4C9FA6",
    secondary: "#005661",
    tertiary: "#E5F1F2",
    trash: "#dc2626",
  },
  warningFunction: {
    yellow: "bg-yellow-400",
    red: "bg-red-600",
    text: "text-white",
    messageText: "text-red-600",
    checklistAddButtonBg: "bg-[#0B9B68]",
    checklistAddButtonBorder: "border-transparent",
    checklistAddButtonHover: "hover:bg-[#08855A]",
  },
  voyageChecklist: {
    tabsContainerBg: "bg-[#F3F4F6]",
    tabInactiveText: "text-[#6B7280]",
    tabInactiveHoverText: "hover:text-[#111827]",
    completionBadgeBg: "bg-[#DDF6EA]",
    completionBadgeBorder: "border-[#B7E7D2]",
    completionBadgeText: "text-[#0B9B68]",
    itemCheckedBorder: "border-[#A7F3D0]",
    itemCheckedBg: "bg-[#ECFDF5]",
    itemCheckedCheckboxBorder: "border-[#0B9B68]",
    itemCheckedCheckboxBg: "bg-[#ECFDF5]",
    itemCheckedText: "text-[#4B5563]",
  },
  vesselDetails: {
    fields: "text-[#899996]",
    info: "text-gray-500",
    emerald: "bg-emerald-50",
    cardBorder: "border-[#E5E7EB]",
    cardBackground: "bg-white",
    statusBadgeBg: "bg-[#0B9B68]",
    statusBadgeText: "text-white",
    tcLinkText: "text-[#0B9B68]",
    menuBtnBorder: "border-light-ash",
    textBtn: "text-light-ash",
    hover: "hover:bg-gray-100",
    linkText: "text-teal-700",
    verticalLine: "bg-gray-300",
    infoText: "text-[#AAA6A5]",
    starFill: "#1086A1",
    focusBorder: "focus:border-blue-300",
    divider: "bg-[#DFE4E2]",
    neutralText: "text-neutral-300",
  },
  balticQuestionnaire: {
    grayBg: "bg-gray-200",
    dividerBg: "bg-gray-300",
    lastScreenBg: "bg-[#effaf6]",
    labelsText: "[&_label]:text-gray-600",
    inputsBg: "[&_input]:bg-white",
    inputsText: "[&_input]:text-gray-700",
    inputsBorder: "[&_input]:border-gray-200",
    inputsFocusBorder: "[&_input:focus]:border-blue-300",
    inputsFocusRing: "[&_input:focus]:ring-blue-300",
    selectsFocusBorder: "[&_select:focus]:border-blue-300",
    selectsFocusRing: "[&_select:focus]:ring-blue-300",
    selectsBorder: "[&_select]:border-gray-200",
    selectsBg: "[&_select]:bg-white",
    selectsText: "[&_select]:text-gray-700",
    textAreasFocusBorder: "[&_textarea:focus]:border-blue-300",
    textAreasFocusRing: "[&_textarea:focus]:ring-blue-300",
    blueText: "text-blue-500",
    textsBg: "[&_textarea]:bg-white",
    textsText: "[&_textarea]:text-gray-700",
    textsBorder: "[&_textarea]:border-gray-200",
    selectsScroller: twMerge(
      "[&_select::-webkit-scrollbar]:w-1.5",
      "[&_select::-webkit-scrollbar-thumb]:rounded-full",
      "[&_select]:[scrollbar-width:thin]",
      "[&_select::-webkit-scrollbar-track]:bg-gray-200",
      "[&_select::-webkit-scrollbar-thumb]:bg-gray-400",
    ),
    reactDatePicker: {
      background: "#FFFFFF",
      border: "#E1E5EB",
      selectedDayBg: "#FFFFFF",
      dayHover: "#D4EBE7",
      inputBorder: "#E1E5EB",
      inputBg: "#FFFFFF",
    },
  },
  technicalQuestionnaire: {
    lightGrayText: "text-lightGrey",
    reactInputBg: "#FFFFFF",
    reactInputBorder: "#e5e7eb",
    reactInputText: "#111827",
    reactInputSelected: "#DDDDDD",
    reactSelectFocused: "#D4EBE7",
  },
  voyPnl: {
    rowGreenBg: "bg-[#E8F5F1]",
    rowRedBg: "bg-[#FFEEE8]",
    lightGreyText: "text-gray-400",
    sidePanelHeaderText: "text-[#FFFFFF]",
  },
  voyageItinerary: {
    connector: "bg-gray-300",
    mutedText: "text-slate-500",
    detailsBorder: "border-slate-200",
    detailsBackground: "bg-gray-50",
    badge: {
      C: "bg-blue-100 text-blue-700",
      L: "bg-emerald-100 text-emerald-700",
      P: "bg-slate-100 text-slate-700",
      F: "bg-amber-200 text-amber-800",
      D: "bg-violet-100 text-violet-700",
      W: "bg-slate-100 text-slate-700",
      Y: "bg-sky-100 text-sky-700",
      I: "bg-cyan-100 text-cyan-700",
      R: "bg-rose-100 text-rose-700",
      T: "bg-slate-100 text-slate-700",
      Z: "bg-orange-100 text-orange-700",
      O: "bg-slate-100 text-slate-700",
      default: "bg-slate-100 text-slate-700",
    },
    marker: {
      C: "bg-emerald-600 text-white",
      L: "bg-emerald-600 text-white",
      D: "bg-sky-600 text-white",
      F: "bg-slate-400 text-white",
      P: "bg-slate-200 text-slate-600",
      W: "bg-slate-200 text-slate-600",
      O: "bg-orange-300/60 text-orange-600/70",
      default: "bg-slate-300 text-slate-700",
    },
  },
};

export const nightTheme = {
  loadingWrapper: {
    tailwind: {
      overlayBg: "bg-gray-900",
    },
  },
  sideBarComponent: {
    background: {
      default: "#1A1D1F",
      tooltip: "#2A3033",
      activeLink: "#254E47",
    },
    iconAndText: {
      active: "#059080",
      inactive: "#94A3B8",
      tooltipText: "#E1E5E9",
    },
    border: {
      sidebar: "#2F363A",
    },
    tailWind: {
      white: "bg-gray-800",
      greyscale20: "border-gray-700",
    },
  },

  headerComponent: {
    inline: {
      dotActive: "#22A55E",
      dotInactive: "#EF4444",
      tooltipBackground: "#374151",
      tooltipText: "#F9FAFB",
      generalText: "text-gray-400",
    },
    tailwind: {
      buttonBorder: "border-gray-500",
      buttonText: "text-gray-400",
      buttonHoverBg: "hover:bg-green",
      buttonHoverText: "hover:text-gray-900",
      buttonFocusRing: "focus:ring-gray-600/50",
      statusText: "text-gray-400",
      vesselTitleText: "text-gray-400",
      loadingSpinner: "text-gray-200",
      backButtonBg: "bg-gray-700",
      leftArrow: "group-hover:text-gray-900",
    },
    notifications: {
      iconBackground: "bg-gray-700",
      iconShape: "text-gray-400",
      drawerBackground: "bg-gray-700",
      header: "bg-slate-700",
      headerText: "text-gray-400",
      headerIcon: "#B5B5B5",
      headerBorder: "border-b-gray-600",
      border: "border-gray-600",
      isReadBackground: "bg-[#2A2F2E]",
      itemBackground: "bg-[#304655]",
      notificationText: "text-gray-400",
      readDotBorder: "border-gray-400",
    },
    themeSwitch: {
      switchBorder: "border-slate-500",
      switchDot: "bg-gray-400",
    },
    logInCircle: {
      text: "text-gray-400",
    },
    profileMenu: {
      background: "bg-gray-700",
      text: "#94A3B8",
    },
  },

  home: {
    tailwind: {
      textDefault: "text-gray-400",
      pageBackground: "bg-gray-900",
      panelBackground: "bg-gray-800",
      panelShadow: "shadow",
      spinner: "text-green",
      backgound: "bg-gray-900",
      greenBg: "bg-green",
    },
  },

  myVesselsTable: {
    searchIcon: {
      iconColor: "#1F8475",
      outerFill: "#505655",
      innerFill: "#254E47",
      glyphFill: "#1F8475",
    },
    tailwind: {
      tableBorder: "border-gray-600",
      textDefault: "text-gray-400",
      emptyStateIconBg: "bg-gray-700",
      emptyStateText: "text-gray-300",
      linkText: "text-green",
      headBorderY: "after:border-gray-500",
    },
  },

  myVesselsTableRow: {
    status: {
      delivered: { border: "border-[#22A55E]", text: "text-[#22805E]" },
      redelivered: { border: "border-[#B29A58]", text: "text-[#B29A58]" },
      canceled: { border: "border-[#FF4D4F]", text: "text-[#FF4D4F]" },
      closed: { border: "border-[#1BB3C1]", text: "text-[#1BB3C1]" },
      fixed: { border: "border-[#BFBFBF]", text: "text-[#BFBFBF]" },
      default: { border: "border-emerald-400", text: "text-emerald-400" },
    },
    dot: {
      active: "#22AA5E",
      inactive: "#EF4444",
    },
    row: {
      primary: "bg-teal-700",
      primaryDarker: "bg-teal-800",
      primaryMedium: "bg-gray-700",
      hover: "hover:bg-teal-900",
      hoverTwenty: "hover:bg-teal-800",
      text: "text-[#05978b]",
    },
    tooltip: {
      background: "#1A2F2E",
      text: "#E5E7EB",
    },
    tableText: {
      primary: "text-gray-400",
      secondary: "text-gray-500",
    },

    rating: {
      A: { textColor: "#E5E5EB", bgColor: "#075E54" },
      B: { textColor: "#222222", bgColor: "#22A55E" },
      C: { textColor: "#222222", bgColor: "#DDB200" },
      D: { textColor: "#222222", bgColor: "#FF8547" },
      E: { textColor: "#F0F0F0", bgColor: "#E34A54" },
    },

    divider: {
      color: "border-gray-600",
    },
  },
  uwhcAssistant: {
    buttonCenterIcon: "#054050",
    background: "bg-gray-800",
    border: "border-gray-500",
    text: "text-slate-400",
    textOutput: "text-gray-400",
    chatBorder: "border-slate-500",
    chatBg: "bg-slate-700",
    aiReplyBg: "bg-gray-700",
    aiReplyBorder: "border-gray-500",
    scrolThumb: "[&::-webkit-scrollbar-thumb]:bg-slate-500",
    scrolHover: "hover:[&::-webkit-scrollbar-thumb]:bg-slate-400",
    sendBg: "bg-slate-600",
    sendText: "text-slate-400",
    sendBorder: "border-slate-400",
    inputBg: "bg-gray-700",
    inputText: "text-gray-300",
    inputBorder: "border-gray-500",
    theadBg: "bg-gray-700",
    theadText: "text-slate-400",
    buttonBorder: "border-slate-400",
    tableBg: "bg-slate-700",
    tableBgOther: "bg-slate-600",
    tableText: "text-slate-400",
    tableInputBg: "bg-slate-600",
    tableInputText: "text-gray-200",
    tableBorder: "border-gray-400",
    tableRowEven: "bg-gray-800",
    tableRowOdd: "bg-gray-700",
    tableScroll: "[&::-webkit-scrollbar-thumb]:bg-gray-500",
    details: "text-blue-700",
    boolBadge: {
      yesBg: "bg-emerald-900",
      yesText: "text-emerald-400",
      noBg: "bg-red-900",
      noText: "text-red-300",
      unknownBg: "bg-slate-500",
      unknownText: "text-gray-900",
    },
    blueLine: "bg-[#1f8475]",
    chatUi: {
      overlayBackdrop: "bg-black/45",
      launcherButton:
        "bg-[#1F8475] text-white hover:bg-[#176A5E] focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-800",
      panelBg: "bg-gray-800",
      panelBorder: "border-gray-600",
      headerBg: "bg-[linear-gradient(90deg,#334155_0%,#1F2937_100%)]",
      headerBorder: "border-gray-600",
      brandIconBg: "bg-[#254E47]",
      brandIconShadow: "shadow-[0_10px_24px_rgba(15,23,42,0.24)]",
      brandTag: "bg-[#2A3C3A] text-[#A7E0D6]",
      titleText: "text-gray-100",
      subtitleText: "text-slate-400",
      connectionConnected: "bg-[#23433D] text-[#A7E0D6]",
      connectionConnecting: "bg-[#4A4532] text-[#F3D68A]",
      responseBusy: "border-[#476A8E] bg-[#2B3645] text-[#C7DAFF]",
      responseIdle: "border-gray-600 bg-gray-700 text-gray-300",
      closeButton: "border-gray-600 bg-gray-700 text-gray-300",
      closeButtonHover: "hover:border-gray-500 hover:text-white",
      sectionBorder: "border-gray-700",
      conversationTitle: "text-gray-100",
      conversationSubtitle: "text-slate-400",
      countBadge: "bg-gray-700 text-gray-300",
      mainBg: "bg-gray-800",
      mainScrollbar: "[&::-webkit-scrollbar-thumb]:bg-gray-500",
      mainScrollbarTrack: "[&::-webkit-scrollbar-track]:bg-gray-700",
      assistantAvatarBg: "bg-[#254E47]",
      assistantAvatarColor: "#FFFFFF",
      systemAvatarBg: "bg-[#334155]",
      systemAvatarColor: "#CBD5E1",
      assistantMeta: "text-gray-300",
      userBubble: "border-[#2D766A] bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(15,23,42,0.26)]",
      userEyebrow: "text-white/70",
      assistantBubble: "border-gray-600 bg-gray-700 text-gray-100",
      systemBubble: "border-gray-600 bg-slate-700 text-slate-100",
      markdownUser: "[&_p]:text-gray-200",
      markdownAssistant: "[&_p]:text-gray-300",
      tableWrap: "border-gray-600 bg-gray-800",
      feedbackButtonActive: "border-[#1F8475] bg-[#1F8475] text-white",
      feedbackButtonIdle: "border-gray-600 bg-gray-800 text-gray-300",
      feedbackButtonHover: "hover:bg-gray-700",
      timestamp: "text-slate-500",
      typingBubble: "border-gray-600 bg-gray-700 text-gray-100",
      typingDot: "bg-slate-500",
      suggestedBg: "bg-gray-800",
      suggestedBorder: "border-gray-700",
      suggestedChip: "border-gray-600 bg-gray-700 text-gray-300",
      suggestedChipHover: "hover:border-gray-500 hover:bg-gray-600",
      footerBg: "bg-gray-800",
      errorBox: "border-red-800 bg-red-950/40 text-red-300",
      input: "border-gray-600 bg-gray-700 text-gray-100 placeholder:text-gray-400",
      inputFocus: "focus:border-teal-600 focus:bg-gray-700",
      sendButton: "bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(15,23,42,0.26)]",
      sendButtonHover: "hover:bg-[#176A5E]",
      sendButtonDisabled: "disabled:bg-gray-600 disabled:text-gray-300 disabled:shadow-none",
      helperText: "text-gray-400",
      feedbackModalBackdrop: "bg-black/55",
      feedbackModalPanel: "border-gray-600 bg-[linear-gradient(180deg,#374151_0%,#1F2937_100%)]",
      feedbackTagText: "text-[#A7E0D6]",
      feedbackTitle: "text-gray-100",
      feedbackBody: "text-gray-300",
      feedbackClose: "border-gray-600 bg-gray-700 text-gray-300",
      feedbackCloseHover: "hover:text-white",
      feedbackReasonSelected: "border-[#1F8475] bg-[#1F8475] text-white shadow-[0_10px_22px_rgba(15,23,42,0.26)]",
      feedbackReasonIdle: "border-gray-600 bg-gray-700 text-gray-200",
      feedbackReasonHover: "hover:border-gray-500 hover:bg-gray-600",
      feedbackTextarea: "border-gray-600 bg-gray-700 text-gray-100 placeholder:text-gray-400",
      feedbackTextareaFocus: "focus:border-teal-600",
      feedbackSubmit: "bg-[#1F8475] text-white shadow-[0_12px_24px_rgba(15,23,42,0.26)]",
      feedbackSubmitHover: "hover:bg-[#176A5E]",
      feedbackSubmitDisabled: "bg-gray-600 text-gray-300",
    },
  },
  opsKnowledgeAssistant: {
    text: "text-slate-400",
    chatUi: {
      overlayBackdrop: "bg-black/45",
      launcherButton:
        "bg-[#1F8475] text-white hover:bg-[#176A5E] focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-800",
      panelBg: "bg-gray-800",
      panelBorder: "border-gray-600",
      headerBg: "bg-[linear-gradient(90deg,#334155_0%,#1F2937_100%)]",
      headerBorder: "border-gray-600",
      brandIconBg: "bg-[#254E47]",
      brandIconShadow: "shadow-[0_10px_24px_rgba(15,23,42,0.24)]",
      brandTag: "bg-[#2A3C3A] text-[#A7E0D6]",
      titleText: "text-gray-100",
      subtitleText: "text-slate-400",
      connectionConnected: "bg-[#23433D] text-[#A7E0D6]",
      connectionConnecting: "bg-[#4A4532] text-[#F3D68A]",
      responseBusy: "border-[#476A8E] bg-[#2B3645] text-[#C7DAFF]",
      responseIdle: "border-gray-600 bg-gray-700 text-gray-300",
      closeButton: "border-gray-600 bg-gray-700 text-gray-300",
      closeButtonHover: "hover:border-gray-500 hover:text-white",
      sectionBorder: "border-gray-700",
      conversationTitle: "text-gray-100",
      conversationSubtitle: "text-slate-400",
      countBadge: "bg-gray-700 text-gray-300",
      mainBg: "bg-gray-800",
      mainScrollbar: "[&::-webkit-scrollbar-thumb]:bg-gray-500",
      mainScrollbarTrack: "[&::-webkit-scrollbar-track]:bg-gray-700",
      assistantAvatarBg: "bg-[#254E47]",
      assistantAvatarColor: "#FFFFFF",
      systemAvatarBg: "bg-[#334155]",
      systemAvatarColor: "#CBD5E1",
      assistantMeta: "text-gray-300",
      userBubble: "border-[#2D766A] bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(15,23,42,0.26)]",
      userEyebrow: "text-white/70",
      assistantBubble: "border-gray-600 bg-gray-700 text-gray-100",
      systemBubble: "border-gray-600 bg-slate-700 text-slate-100",
      markdownUser: "[&_p]:text-gray-200",
      markdownAssistant: "[&_p]:text-gray-300",
      tableWrap: "border-gray-700 bg-gray-800",
      feedbackButtonActive: "border-[#1F8475] bg-[#1F8475] text-white",
      feedbackButtonIdle: "border-gray-600 bg-gray-800 text-gray-300",
      feedbackButtonHover: "hover:bg-gray-700",
      timestamp: "text-gray-500",
      typingBubble: "border-gray-600 bg-gray-700 text-gray-100",
      typingDot: "bg-slate-500",
      suggestedBg: "bg-gray-800",
      suggestedBorder: "border-gray-700",
      suggestedChip: "border-gray-600 bg-gray-700 text-gray-300",
      suggestedChipHover: "hover:border-gray-500 hover:bg-gray-600",
      footerBg: "bg-gray-800",
      errorBox: "border-red-900 bg-red-950/40 text-red-300",
      input: "border-gray-600 bg-gray-700 text-gray-100 placeholder:text-gray-400",
      inputFocus: "focus:border-teal-600 focus:bg-gray-700",
      sendButton: "bg-[#1F8475] text-white shadow-[0_12px_26px_rgba(15,23,42,0.26)]",
      sendButtonHover: "hover:bg-[#176A5E]",
      sendButtonDisabled: "disabled:bg-gray-600 disabled:text-gray-300 disabled:shadow-none",
      helperText: "text-gray-400",
      feedbackModalBackdrop: "bg-black/55",
      feedbackModalPanel: "border-gray-600 bg-[linear-gradient(180deg,#374151_0%,#1F2937_100%)]",
      feedbackTagText: "text-[#A7E0D6]",
      feedbackTitle: "text-gray-100",
      feedbackBody: "text-gray-300",
      feedbackClose: "border-gray-600 bg-gray-700 text-gray-300",
      feedbackCloseHover: "hover:text-white",
      feedbackReasonSelected: "border-[#1F8475] bg-[#1F8475] text-white shadow-[0_10px_22px_rgba(15,23,42,0.26)]",
      feedbackReasonIdle: "border-gray-600 bg-gray-700 text-gray-200",
      feedbackReasonHover: "hover:border-gray-500 hover:bg-gray-600",
      feedbackTextarea: "border-gray-600 bg-gray-700 text-gray-100 placeholder:text-gray-400",
      feedbackTextareaFocus: "focus:border-teal-600",
      feedbackSubmit: "bg-[#1F8475] text-white shadow-[0_12px_24px_rgba(15,23,42,0.26)]",
      feedbackSubmitHover: "hover:bg-[#176A5E]",
      feedbackSubmitDisabled: "bg-gray-600 text-gray-300",
    },
  },
  circleText: {
    background: "bg-teal-700",
    text: "text-slate-900",
  },
  crtDropdown: {
    open: "#1F8475",
    openBg: "bg-[#1F8475]",
    error: "#BF0002",
    closed: "#899996",
    errorText: "text-[#BF0002]",
    hoverGreen: "hover:bg-[#217968]",
  },
  crtDropInput: {
    green: "#05978b",
    placeholderTextGreen: "placeholder:text-[#05978b]",
    greenHover: "hover:border-[#05978b]",
    hoverText: "hover:text-green",
    hoverPlaceholder: "hover:placeholder:text-green",
    focusBorder: "focus:border-[#05978b]",
    focusVisibleBorder: "focus-visible:border-[#05978b]",
    error: "#BF0002",
    borderError: "border-[#BF0002]",
    textError: "text-[#BF0002]",
    placeholderTextError: "placeholder:text-[#BF0002]",
    textDefault: "#6B7280",
    textGreen: "text-green",
    borderGreen: "border-green",
    dashedBorder: "border-green",
    dashedBg: "bg-green",
  },
  certVesselSelect: {
    tableBorder: "border-gray-600",
    tableBg: "bg-gray-800",
    hoverSelect: "hover:bg-[#255050]",
    tableText: "text-gray-400",
    tabsBg: "#9ca3af",
  },
  certDocumentIcon: {
    circle: "#2E696B",
    primary: "#20807F",
    secondary: "#027077",
    tertiary: "#446070",
    trash: "#dc2626",
  },
  warningFunction: {
    yellow: "bg-yellow-600",
    red: "bg-red-600",
    text: "text-gray-900",
    messageText: "text-red-600",
    checklistAddButtonBg: "bg-[#1F8475]",
    checklistAddButtonBorder: "border-[#2D766A]",
    checklistAddButtonHover: "hover:bg-[#176A5E]",
  },
  voyageChecklist: {
    tabsContainerBg: "bg-gray-700",
    tabInactiveText: "text-gray-400",
    tabInactiveHoverText: "hover:text-gray-200",
    completionBadgeBg: "bg-emerald-900/40",
    completionBadgeBorder: "border-emerald-800/80",
    completionBadgeText: "text-[#D1FAE5]",
    itemCheckedBorder: "border-emerald-800",
    itemCheckedBg: "bg-emerald-950/30",
    itemCheckedCheckboxBorder: "border-emerald-600",
    itemCheckedCheckboxBg: "bg-emerald-900/30",
    itemCheckedText: "text-gray-500",
  },
  vesselDetails: {
    fields: "text-[#96A6BF]",
    info: "text-gray-400",
    emerald: "bg-emerald-900",
    cardBorder: "border-gray-600",
    cardBackground: "bg-gray-800",
    statusBadgeBg: "bg-[#1F8475]",
    statusBadgeText: "text-white",
    tcLinkText: "text-teal-400",
    menuBtnBorder: "border-gray-600",
    textBtn: "text-slate-400",
    hover: "hover:bg-gray-700",
    linkText: "text-teal-400",
    verticalLine: "bg-gray-600",
    infoText: "text-[#AAA6A5]",
    starFill: "#106681",
    focusBorder: "focus:border-teal-600",
    divider: "bg-gray-600",
    neutralText: "text-neutral-400",
  },
  balticQuestionnaire: {
    grayBg: "bg-gray-700",
    dividerBg: "bg-gray-500",
    lastScreenBg: "bg-[#204B48]",
    labelsText: "[&_label]:text-gray-400",
    inputsBg: "[&_input]:bg-gray-900",
    inputsText: "[&_input]:text-slate-400",
    inputsBorder: "[&_input]:border-gray-500",
    inputsFocusBorder: "[&_input:focus]:border-teal-800",
    inputsFocusRing: "[&_input:focus]:ring-teal-800",
    selectsFocusBorder: "[&_select:focus]:border-teal-800",
    selectsFocusRing: "[&_select:focus]:ring-teal-800",
    selectsBorder: "[&_select]:border-gray-500",
    selectsBg: "[&_select]:bg-gray-900",
    selectsText: "[&_select]:text-slate-400",
    textAreasFocusBorder: "[&_textarea:focus]:border-teal-800",
    textAreasFocusRing: "[&_textarea:focus]:ring-teal-800",
    blueText: "text-teal-700",
    textsBg: "[&_textarea]:bg-gray-900",
    textsText: "[&_textarea]:text-slate-400",
    textsBorder: "[&_textarea]:border-gray-500",
    selectsScroller: twMerge(
      "[&_select::-webkit-scrollbar]:w-1.5",
      "[&_select::-webkit-scrollbar-thumb]:rounded-full",
      "[&_select]:[scrollbar-width:thin]",
      "[&_select::-webkit-scrollbar-track]:bg-gray-400",
      "[&_select::-webkit-scrollbar-thumb]:bg-gray-500",
    ),
    reactDatePicker: {
      background: "#3A454F",
      border: "#1f8475",
      selectedDayBg: "#2A353F",
      dayHover: "#1f8475",
      inputBorder: "#6B7280",
      inputBg: "#1f2937",
    },
  },
  technicalQuestionnaire: {
    lightGrayText: "text-gray-400",
    reactInputBg: "#111827",
    reactInputBorder: "#6b7280",
    reactInputText: "#9CA3AF",
    reactInputSelected: "#AAAAAA",
    reactSelectFocused: "#05978b",
  },
  voyPnl: {
    rowGreenBg: "bg-[#0F231D]",
    rowRedBg: "bg-[#310D01]",
    lightGreyText: "text-gray-400",
    sidePanelHeaderText: "text-gray-300",
  },
  voyageItinerary: {
    connector: "bg-gray-600",
    mutedText: "text-gray-400",
    detailsBorder: "border-gray-500",
    detailsBackground: "bg-gray-700",
    badge: {
      C: "bg-blue-950 text-blue-300",
      L: "bg-emerald-950 text-emerald-300",
      P: "bg-gray-700 text-gray-300",
      F: "bg-amber-800/70 text-amber-600",
      D: "bg-sky-950 text-sky-300",
      W: "bg-gray-700 text-gray-300",
      Y: "bg-sky-950 text-sky-300",
      I: "bg-cyan-950 text-cyan-300",
      R: "bg-rose-950 text-rose-300",
      T: "bg-gray-700 text-gray-300",
      Z: "bg-orange-950 text-orange-300",
      O: "bg-gray-700 text-gray-300",
      default: "bg-gray-700 text-gray-300",
    },
    marker: {
      C: "bg-emerald-700 text-gray-900",
      L: "bg-emerald-700 text-gray-900",
      D: "bg-sky-700 text-slate-900",
      F: "bg-gray-500 text-slate-900",
      P: "bg-gray-600 text-gray-900",
      W: "bg-gray-600 text-gray-900",
      O: "bg-orange-800/60 text-gray-500",
      default: "bg-gray-600 text-gray-900",
    },
  },
};
